const SPLIT_BOUNDS_BRANDED_FARE_PARAMS = [
    "baseOfferToken",
    "brandedFareIndex",
    "outboundBrandedFareToken",
    "outboundBrandedFareIdx",
    "outboundBrandedFareName",
    "outboundBrandedFareTravellerPrice",
    "limit"
];
export function clearSplitBoundsBrandedFareParams(params) {
    SPLIT_BOUNDS_BRANDED_FARE_PARAMS.forEach((param) => params.delete(param));
}
